import * as Styled from './styles';
import WarningsList from './components/WarningsList';
import { ResultDeatilProps } from './types';

const ResultDetail = ({ warning }: ResultDeatilProps): JSX.Element | null => {
  return (
    <Styled.Container>
      {warning && warning.length > 0 && <WarningsList warning={warning} />}
    </Styled.Container>
  );
};

export default ResultDetail;
